import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, offeringsService } from '@v2/services';
import type { CreateOfferingPayload } from '@v2/types';

export const useCreateOffering = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ partnerId, payload }: { partnerId: string; payload: CreateOfferingPayload }) =>
      offeringsService.createPartnerOffering(partnerId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.offerings.partner.all);
      queryClient.invalidateQueries(queryKeys.partners.all);
    },
  });

  const createOffering = async (
    partnerId: string,
    payload: CreateOfferingPayload,
  ): Promise<boolean> => {
    try {
      await mutation.mutateAsync({ partnerId, payload });
      return true;
    } catch {
      return false;
    }
  };

  return {
    createOffering,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useCreateOffering;
